import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { useArchiveExperience } from "@src/api/experiences/archive-experience";
import { PERSONALIZATION_ROUTES } from "@src/routes/routes";
import { isDialogOpen, setDialog } from "@src/store/slices/global";

export interface ArchivePersonalizationDialogProps {
  experienceId: string | null | undefined;
  repopulate?: boolean;
  shouldNavigate?: boolean;
}

export const ArchivePersonalizationDialog = ({
  experienceId,
  repopulate,
  shouldNavigate = true,
}: ArchivePersonalizationDialogProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const archiveExperience = useArchiveExperience(repopulate);
  const isOpen = useSelector(isDialogOpen("archivePersonalization"));

  const handleClose = () => {
    dispatch(setDialog({ dialog: "archivePersonalization", open: false }));
  };

  const handleArchive = () => {
    if (experienceId) {
      archiveExperience.mutate({
        body: undefined,
        pathParams: { experienceId: experienceId },
        queryParams: undefined,
      });
      dispatch(setDialog({ dialog: "archivePersonalization", open: false }));
      if (shouldNavigate) {
        void navigate(PERSONALIZATION_ROUTES.Personalizations, {
          state: {
            targetId: experienceId,
            expanded: true,
            archive: true,
            unarchive: false,
          },
        });
      }
    }
  };

  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={handleClose}
      title={"Archive Experience?"}
      handleYesClick={handleArchive}
      yesButtonText={"Archive"}
      rawContent={
        <Grid container item>
          <IgTypography>
            Archiving an Experience hides it without permanently deleting it.
            With a limit of 15 active offers, archiving this Experience will
            create room for you to add or activate new offers.
          </IgTypography>
          <Box my={2}>
            <IgTypography>
              Are you sure you want to archive this Experience?
            </IgTypography>
          </Box>
          <IgTypography component="div">
            <ul>
              <li tabIndex={0}>It will be made inactive if not already</li>
              <li tabIndex={0}>Any schedule will be removed</li>
              <li tabIndex={0}>
                You will not be able to preview it or activate it
              </li>
              <li tabIndex={0}>You can unarchive it at any point</li>
            </ul>
          </IgTypography>
        </Grid>
      }
    />
  );
};
